import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { authInterceptor } from '@core/auth/auth.interceptor';
import { errorInterceptor } from '@core/auth/error.interceptor';
import { provideAppEnvironment } from '@core/config/app-environment';
import {
  EventTrackerErrorHandler,
  eventTrackerInterceptor,
  provideGlobalErrorListeners,
} from '@core/event-tracker';
import { routes } from './app.routes';

/**
 * Zoneless (Angular 22 default). Material 22 does not depend on @angular/animations, so no
 * animations provider is needed (provideAnimations/provideAnimationsAsync are deprecated).
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideAppEnvironment(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch(), withInterceptors([eventTrackerInterceptor, authInterceptor, errorInterceptor])),
    { provide: ErrorHandler, useClass: EventTrackerErrorHandler },
    provideGlobalErrorListeners(),
  ],
};
